import React from 'react';
import BaseComponent from './BaseComponent';
import Style from './MissionIntro.cssmodule.less';
import classNames from 'classnames';

class MissionIntro extends BaseComponent {
    constructor(props) {
        super(props);
        this.handleClickEvent = this.handleClickEvent.bind(this);
    }

    handleClickEvent(e, data) {
        this.props.emitter.emit('click', e, data);
    }

    render() {
        const { content = {} } = this.props;
        const { text, image, btnText, type } = content;
        return (
            <div className={classNames(Style.missionIntro, 'mission_intro')}>
                <div className={classNames(Style.iconArea, 'icon_area')}>
                    <img src={image} />
                </div>
                <div className={classNames(Style.textArea, 'intro_text_area')}>
                    <div className={Style.cell}>
                        <span className={Style.text}>{text}</span>
                    </div>
                </div>
                <span
                    className={classNames(Style.btn_complete, 'intro_button')}
                    onClick={(e) => this.handleClickEvent(e, {type})}>
                    {btnText}
                </span>
            </div>
        );
    }
}

MissionIntro.displayName = 'MissionIntro';
MissionIntro.propTypes = {};

export default MissionIntro;



// WEBPACK FOOTER //
// ./components/CommonSet/MissionIntro.js